# frozen_string_literal: true

# backtick_javascript: true

`Opal.config.unsupported_features_severity = 'ignore'`
require 'logger'
require 'native'
require 'json'
require 'snabberb'
require 'vendor/big'
require 'vendor/polyfill'
require 'vendor/message-bus'
require 'vendor/message-bus-ajax'
